import { FunctionComponent, useContext, useEffect, useState } from "react";
import { useTranslation } from "next-i18next/pages";
import { useInView } from "react-intersection-observer";
import AppContext from "context/AppContext";
import styles from "../../styles/about/FounderStory.module.css";

interface FounderStoryProps {}

const FounderStory: FunctionComponent<FounderStoryProps> = () => {
  const { isMobile } = useContext(AppContext);
  const { t } = useTranslation("about");
  const paragraphs: string[] = t("founder.paragraphs", {
    returnObjects: true
  }) as string[];
  const quotes: string[] = t("founder.quotes", { returnObjects: true }) as string[];
  const services: string[] = t("founder.services", { returnObjects: true }) as string[];
  const [isAnimationOn, setIsAnimationOn] = useState<boolean>(false);
  const { ref, inView } = useInView({ rootMargin: "0% 0% -5%" });

  useEffect(() => {
    if (inView) {
      setIsAnimationOn(true);
    }
  }, [inView]);

  return (
    <section
      className={`${styles.founderContainer} ${
        isAnimationOn && !isMobile ? styles.animated : ""
      }`}
      ref={ref}
    >
      <h3 className={styles.title}>{t("founder.title")}</h3>

      <div className={styles.content}>
        <div className={styles.story}>
          {paragraphs.map((paragraph: string, index: number) => (
            <p key={index} className={styles.paragraph}>
              {paragraph}
            </p>
          ))}

          {Array.isArray(quotes) && quotes.length > 0 && (
            <div className={styles.quotesSection}>
              {quotes.map((quote: string, index: number) => (
                <blockquote key={index} className={styles.quote}>
                  <p>{quote}</p>
                </blockquote>
              ))}
            </div>
          )}
        </div>

        <div className={styles.sidebar}>
          <div className={styles.infoCard}>
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>{t("founder.locationLabel")}</span>
              <span className={styles.infoValue}>
                {t("founder.location")}
              </span>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>{t("founder.languagesLabel")}</span>
              <span className={styles.infoValue}>
                {t("founder.languages")}
              </span>
            </div>
          </div>

          <div className={styles.servicesCard}>
            <h4 className={styles.servicesTitle}>{t("founder.servicesLabel")}</h4>
            <div className={styles.servicesTags}>
              {services.map((service: string, index: number) => (
                <span key={index} className={styles.serviceTag}>
                  {service}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStory;
